import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useEffect, useState } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";

export const ProtectedRoute = () => {
    // const auth = getAuth();
  
    if (localStorage.getItem("user") == null) {
      return <Navigate to="/login" replace />;
    }
    
    return <Outlet />;
};